<template>
    <div class="row">
        <div class="col-sm-12">
            <form @submit.prevent="validateBeforeSubmit">
                <b-tabs class="mb-3" v-if="languages.length > 0">
                    <b-tab :key="language.id" :title="language.name" ref="tabLanguage"
                        v-for="language in languages">
                        <div class="b-form-group form-group mb-0">
                            <div class="form-row mb-0" id="container_country">
                                <label class="col-sm-1 col-form-label" for="inclusion_name">{{ $t('inclusions.inclusion_name')
                                    }}</label>
                                <div class="col-sm-4">
                                    <input :class="{'form-control':true }"
                                        id="inclusion_name" name="inclusion_name"
                                        type="text"
                                        v-model="form.translations[language.id].inclusion_name" v-validate="'required'">
                                    <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                        <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                        style="margin-left: 5px;" v-show="errors.has('inclusion_name')"/>
                                        <span v-show="errors.has('inclusion_name')">{{ errors.first('inclusion_name') }}</span>
                                    </div>
                                </div>
                                <template v-if="form.translations[language.id].inclusion_name">
                                    <template v-if="language.iso == 'es'">
                                        <IntentoButton
                                            :item="'inclusion_name'"
                                            :form.sync="form"
                                            :languages="languages"
                                            :language_id="language.id"
                                            :fields="['translations']" />
                                    </template>
                                    <template v-else>
                                        <IntentoButton
                                            :type="'feedback'"
                                            :item="'inclusion_name'"
                                            :field="'translations'"
                                            :form.sync="form"
                                            :languages="languages"
                                            :language_id="language.id" />
                                    </template>
                                </template>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-1 col-form-label">Operatividad</label>
                        <div class="col-sm-4">
                            <b-button-group>
                                <b-button @click="changeOpe(form.days.monday,'monday')" :disabled="loading"
                                          :class="{'bg-success': form.days.monday,'bg-danger':!form.days.monday}">L
                                </b-button>
                                <b-button @click="changeOpe(form.days.tuesday,'tuesday')" :disabled="loading"
                                          :class="{'bg-success': form.days.tuesday,'bg-danger':!form.days.tuesday}">M
                                </b-button>
                                <b-button @click="changeOpe(form.days.wednesday,'wednesday')" :disabled="loading"
                                          :class="{'bg-success': form.days.wednesday,'bg-danger':!form.days.wednesday}">M
                                </b-button>
                                <b-button @click="changeOpe(form.days.thursday,'thursday')" :disabled="loading"
                                          :class="{'bg-success': form.days.thursday,'bg-danger':!form.days.thursday}">J
                                </b-button>
                                <b-button @click="changeOpe(form.days.friday,'friday')" :disabled="loading"
                                          :class="{'bg-success': form.days.friday,'bg-danger':!form.days.friday}">V
                                </b-button>
                                <b-button @click="changeOpe(form.days.saturday,'saturday')" :disabled="loading"
                                          :class="{'bg-success': form.days.saturday,'bg-danger':!form.days.saturday}">S
                                </b-button>
                                <b-button @click="changeOpe(form.days.sunday,'sunday')" :disabled="loading"
                                          :class="{'bg-success': form.days.sunday,'bg-danger':!form.days.sunday}">D
                                </b-button>
                            </b-button-group>
                        </div>
                    </div>
                </div>

            </form>
        </div>
        <div class="col-sm-6">
            <div slot="footer">
                <img src="/images/loading.svg" v-if="loading" width="40px"/>
                <button @click="validateBeforeSubmitOpt" class="btn btn-success" type="submit" v-if="!loading && !hasClient">
                    <font-awesome-icon :icon="['fas', 'dot-circle']"/>
                    {{ $t('global.buttons.submit') }}
                </button>
                <button @click="validateBeforeSubmit" class="btn btn-success" type="submit" v-if="!loading && hasClient">
                    <font-awesome-icon :icon="['fas', 'dot-circle']"/>
                    {{ $t('global.buttons.submit') }}
                </button>
                <router-link :to="{ name: 'InclusionsList' }" v-if="!loading">
                    <button class="btn btn-danger" type="reset">
                        {{ $t('global.buttons.cancel') }}
                    </button>
                </router-link>
            </div>
        </div>
        <b-modal title="Notificaciones" centered ref="my-modal-notify" size="md">
            <div class="row" v-show="!optionSelect">
                <div class="col-md-12">
                    <p class="text-center">¿Desea enviar una notificación de los cambios realizados?</p>
                </div>
            </div>
            <div class="form-group row" v-show="optionSelect">
                <div class="col-sm-12">
                    <label for="name_service">Emails</label>
                    <multiselect :clear-on-select="false"
                                 :close-on-select="false"
                                 :hide-selected="true"
                                 :multiple="true"
                                 :options="emails"
                                 placeholder="Emails"
                                 :preserve-search="true"
                                 tag-placeholder="Emails"
                                 :taggable="true"
                                 @tag="addEmail"
                                 label="name"
                                 ref="multiselect"
                                 track-by="email"
                                 v-model="emailsService">
                    </multiselect>
                </div>
                <div class="col-md-12">
                    <label for="name_service">Mensaje</label>
                    <textarea :class="{'form-control':true }"
                              id="message" name="descripction"
                              rows="3"
                              v-model="form_notify.message"></textarea>
                </div>
            </div>
            <template slot="modal-footer">
                <div class="row" v-show="!optionSelect">
                    <div class="col-md-12">
                        <button @click="optionSelection(1)" class="btn btn-success" type="reset" v-if="!loading">
                            Si, enviar y guardar
                        </button>
                        <button @click="optionSelection(2)" class="btn btn-secondary" type="reset" v-if="!loading">
                            No, solo guardar
                        </button>
                    </div>
                </div>
                <div class="row" v-show="optionSelect">
                    <div class="col-md-12">
                        <button @click="optionSelection(3)" class="btn btn-success" type="reset" v-if="!loading">
                            Enviar y guardar
                        </button>
                        <button @click="hideModal()" class="btn btn-danger" type="reset" v-if="!loading">
                            {{$t('global.buttons.cancel')}}
                        </button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { API } from './../../api'
    import BModal from 'bootstrap-vue/es/components/modal/modal'
    import Multiselect from 'vue-multiselect'

    // Intento..
    import BTab from 'bootstrap-vue/es/components/tabs/tab'
    import BTabs from 'bootstrap-vue/es/components/tabs/tabs'
    import IntentoButton from '../../components/IntentoButton.vue'

    export default {
        components: {
            BModal,
            Multiselect,
            BTabs,
            BTab,
            IntentoButton,
        },
        data: () => {
            return {
                languages: [],
                emailsService: [],
                emails: [],
                inclusion: null,
                showError: false,
                currentLang: '1',
                invalidError: false,
                countError: 0,
                loading: false,
                optionSelect: false,
                formAction: 'post',
                form_notify: {
                    message: ''
                },
                form: {
                    translations: {
                        '1': {
                            'id': '',
                            'inclusion_name': ''
                        }
                    },
                    days: {
                        monday: true,
                        tuesday: true,
                        wednesday: true,
                        thursday: true,
                        friday: true,
                        saturday: true,
                        sunday: true,
                    }
                },
                client_id: '',
                hasClient: false,
            }
        },
        created () {
            this.client_id = window.localStorage.getItem('client_id')
            this.hasClient = !!(window.localStorage.getItem('client_id') && window.localStorage.getItem('client_id') !== '')
        },
        computed: {},
        mounted: function () {
            API.get('users/notification/service').then((result) => {
                let emails = result.data.data
                emails.forEach((email) => {
                    this.emails.push({
                        name: email.name + ' <' + email.email + '>',
                        email: email.email
                    })
                })
            })
            API.get('/languages/')
                .then((result) => {
                    this.languages = result.data.data
                    this.currentLang = result.data.data[0].id
                    let form = this.form
                    let languages = this.languages
                    languages.forEach((value) => {
                        form.translations[value.id] = {
                            id: '',
                            inclusion_name: ''
                        }
                    })
                    if (this.$route.params.id !== undefined) {

                        API.get('/inclusions/' + this.$route.params.id)
                            .then((result) => {
                                this.inclusion = result.data.data
                                this.formAction = 'put'

                                let arrayTranslations = this.inclusion[0].translations
                                arrayTranslations.forEach((translation) => {
                                    form.translations[translation.language_id] = {
                                        id: translation.id,
                                        inclusion_name: translation.value
                                    }
                                })

                                form.days.monday = !!(this.inclusion[0].monday)
                                form.days.tuesday = !!(this.inclusion[0].tuesday)
                                form.days.wednesday = !!(this.inclusion[0].wednesday)
                                form.days.thursday = !!(this.inclusion[0].thursday)
                                form.days.friday = !!(this.inclusion[0].friday)
                                form.days.saturday = !!(this.inclusion[0].saturday)
                                form.days.sunday = !!(this.inclusion[0].sunday)

                            }).catch(() => {
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: this.$t('inclusions.error.messages.name'),
                                text: this.$t('inclusions.error.messages.connection_error')
                            })
                        })
                    }

                    this.form = form
                }).catch(() => {
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: this.$t('inclusions.error.messages.name'),
                    text: this.$t('inclusions.error.messages.connection_error')
                })
            })
        },
        methods: {
            validateBeforeSubmitOpt () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.optionSelect = false
                        this.$refs['my-modal-notify'].show()
                    } else {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: this.$t('global.modules.inclusions'),
                            text: this.$t('inclusions.error.messages.information_complete')
                        })
                        this.loading = false
                    }
                })
            },
            validateBeforeSubmit () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.submit()
                    } else {
                        this.hideModal()
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: this.$t('global.modules.inclusions'),
                            text: this.$t('inclusions.error.messages.information_complete')
                        })
                        this.loading = false
                    }
                })
            },
            submit () {
                this.loading = true
                this.form.hasNotify = this.optionSelect
                this.form.emails = this.emailsService
                this.form.message = this.form_notify.message
                API({
                    method: this.formAction,
                    url: 'inclusions' + (this.$route.params.id !== undefined ? '/'+this.$route.params.id : ''),
                    data: this.form
                })
                    .then((result) => {
                        if (result.data.success === false) {
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: this.$t('global.modules.inclusions'),
                                text: this.$t('inclusions.error.messages.information_error')
                            })
                            this.loading = false
                        } else {
                            this.$router.push('/inclusions/list')
                        }
                    }).catch(() => {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: this.$t('inclusions.error.messages.name'),
                        text: this.$t('inclusions.error.messages.connection_error')
                    })
                })
            },
            remove () {
                this.loading = true
                API({
                    method: 'DELETE',
                    url: 'inclusions/' + (this.$route.params.id !== undefined ? this.$route.params.id : '')
                })
                    .then((result) => {
                        if (result.data.success === true) {
                            this.$router.push('/inclusions/list')
                        } else {
                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: this.$t('global.modules.inclusions'),
                                text: this.$t('inclusions.error.messages.country_delete')
                            })

                            this.loading = false
                        }
                    }).catch(() => {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: this.$t('inclusions.error.messages.name'),
                        text: this.$t('inclusions.error.messages.connection_error')
                    })
                })
            },
            optionSelection: function (option) {
                if (option === 1) {
                    this.optionSelect = true
                } else if (option === 2) {
                    this.$refs['my-modal-notify'].hide()
                    this.validateBeforeSubmit()
                    this.$validator.reset() //solution
                } else {
                    if (this.emailsService.length === 0) {
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: this.$t('global.modules.services'),
                            text: 'Debe seleccionar al menos un email'
                        })
                    } else {
                        this.$refs['my-modal-notify'].hide()
                        this.submit()
                    }
                }
            },
            addEmail (newTag) {
                const tag = {
                    name: newTag,
                    email: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.emailsService.push(tag)
            },
            hideModal () {
                this.optionSelect = false
                this.$refs['my-modal-notify'].hide()
            },
            changeOpe(status,day){
              this.$set(this.form.days,day,(status == true) ? false : true)
            }
        }
    }
</script>

<style lang="stylus">
    #container_country
        margin-bottom 15px
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
